import React from "react";

import { Grid } from "@mui/material";
import PropTypes from "prop-types";

import ErrorBoundaryReport from "./ErrorBoundaryReport";

class ErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      message: null,
      stacktrace: null,
      title: props.title,
    };
  }

  render() {
    if (this.state.hasError) {
      if (this.props.item) {
        return (
          <Grid size={12}>
            <ErrorBoundaryReport />
          </Grid>
        );
      }

      return <ErrorBoundaryReport />;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  item: PropTypes.bool,
  title: PropTypes.string,
};

export default ErrorBoundary;
